export const ROUTES = {
  // Auth
  LOGIN: '/login',
  SIGNUP: '/signup',
  LOGOUT: '/logout',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',

  // Dashboard
  DASHBOARD: '/dashboard',

  // Devices
  DEVICES: '/devices',
  DEVICE_DETAIL: '/devices/:deviceId',
  DEVICE_EDIT: '/devices/:deviceId/edit',
  DEVICE_HISTORY: '/devices/:deviceId/history',
  DEVICE_NEW: '/devices/new',
  DEVICE_CLAIM_CODES: '/devices/claim-codes',

  // Accounts
  ACCOUNTS: '/accounts',
  ACCOUNT_DETAIL: '/accounts/:accountId',
  ACCOUNT_EDIT: '/accounts/:accountId/edit',
  ACCOUNT_NEW: '/accounts/new',

  // Alerts
  ALERTS: '/alerts',
  ALERT_DETAIL: '/alerts/:alertId',
  ALERT_EDIT: '/alerts/:alertId/edit',
  ALERT_NEW: '/alerts/new',

  // Users
  USERS: '/users',
  USER_NEW: '/users/new',
  USER_DETAIL: '/users/:userId',
  USER_EDIT: '/users/:userId/edit',
  USER_PROFILE: '/profile',

  // Settings
  SETTINGS: '/settings',

  // Admin
  ADMIN_NOC: '/admin/noc',
} as const
